export default __webpack_public_path__ + "static/media/enova.6cbb042e.png";